import { formatDate } from '@angular/common';
import { PoolConsumptionStatus } from 'api/types/endpoints/getPoolConsumption';
import { PoolConsumptionPoolDetail } from 'api/types/endpoints/getPoolConsumptionById';
import moment from 'moment';

export function isPoolConsumptionEditable<P extends { status: PoolConsumptionStatus, poolDetails: PoolConsumptionPoolDetail}>(poolConsumption: P): boolean {
  const { status, poolDetails } = poolConsumption;

  return !['inactive', 'completed'].includes(status) && ![ 'archived', 'completed' ].includes(poolDetails?.poolStatus);
}

export function isPoolConsumptionCopy<P extends {status: PoolConsumptionStatus}>(pool: P): boolean {
  const { status } = pool;
  return [ 'open', 'scheduled' ].includes(status);
}


export function isPoolConsumptionEnds<P extends { endDate: string }>(pool: P): boolean {
  const { endDate } = pool;

  var currentDate = moment.utc().format('YYYY-MM-DD');

  const StartDateOnly = endDate;

  if (StartDateOnly < currentDate) {
    return true;
  }

  return false;
}
